import OwlImage from '../../assets/OwlImage.png';
import CrossImage from '../../assets/CrossImage.png';
import MobileImage from '../../assets/MobileImage.png';
import styled from 'styled-components';
import { Paragraph } from '../../../Paragraph/Paragraph';

const items = [
  {
    image: OwlImage,
    text: '<strong>24/7</strong><br/> Multilingual customer support',
    size: 'small',
  },
  {
    image: CrossImage,
    text: '<strong>AIR DOCTOR app</strong><br/> Easily book <strong>in-person or online appointments</strong> with doctors near you',
    size: 'medium',
  },
  {
    image: MobileImage,
    text: '<strong>Country hopping</strong><br/>Up to 5-day trips with the same coverage',
    size: 'small',
  },
];

const MiddleSection = () => {
  return (
    <Wrapper>
      {items.map((item, index) => (
        <ItemWrapper key={index} size={item.size}>
          <Image src={item.image} alt={`Item ${index + 1}`} />
          {item.text && <Paragraph text={item.text} />}
        </ItemWrapper>
      ))}
    </Wrapper>
  );
};

export default MiddleSection;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 93px;
  gap: 90px;

  @media (min-width: 768px) {
    justify-content: center;
    gap: 80px;
    margin-top: 118px;
  }

  @media (min-width: 1024px) {
    margin-top: 104px;
    gap: 40px;
    flex-direction: row;
  }
`;

const ItemWrapper = styled.div<{ size: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 116px;
  border-radius: 10px;
  background: #a8e8d3;
  justify-content: center;
  text-align: center;
  position: relative;
  padding: 20px 35px 16px 35px;

  @media (min-width: 768px) {
    border-radius: 35px;
    width: 524px;
    height: 190px;
    padding: 70px 60px 30px 60px;
    gap: 50px;
  }

  @media (min-width: 1024px) {
    width: ${({ size }) => (size === 'small' ? '294px' : size === 'medium' ? '414px' : '100%')};
    height: 225px;
    padding: 16px;
    gap: 50px;
  }
`;

const Image = styled.img`
  position: absolute;
  height: 65px;
  top: -40px;

  @media (min-width: 768px) {
    height: 82px;
  }
`;
